[
    "🙂",
    "😀",
    "😃",
    "😄",
    "😁",
    "😅",
    "😆",
    "🤣",
    "😂",
    "🙃",
    "😉",
    "😊",
    "😇",
    "😎",
    "🤓",
    "🧐",
    "🥳",
    "🥰",
    "😍",
    "🤩",
    "😘",
    "😗",
    "😚",
    "😙",
    "😋",
    "😛",
    "😜",
    "🤪",
    "😝",
    "🤑",
    "🤗",
    "🤭",
    "🤫",
    "🤔",
    "😐",
    "🤐",
    "🤨",
    "😑",
    "😶",
    "😏",
    "😒",
    "🙄",
    "😬",
    "🤥",
    "😪",
    "😴",
    "😌",
    "😔",
    "🤤",
    "😷",
    "🤒",
    "🤕",
    "🤢",
    "🤮",
    "🤧",
    "🥵"
  ]